import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// material-ui
import withStyles from "@material-ui/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class FormTeam extends Component {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    team: PropTypes.object,

    createTeam: PropTypes.func,
    updateTeam: PropTypes.func,
    deleteTeam: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      name: "",
      description: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.team);
    }
  }

  handleChange = (name) => (event) => {
    const { target } = event;
    const { value } = target;

    this.setState({
      [name]: value,
    });
  };

  init(team) {
    this.setState({
      loading: false,
      name: team ? team.name : "",
      description: team ? team.description : "",
      dateTo: team ? team.dateTo : "",
      dateFrom: team ? team.dateFrom : "",
    });
  }

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: "Are you sure ?",
        subtitle: "If you delete this team, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const { deleteTeam, close, refresh, team } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteTeam(team.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "Team has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const { updateTeam, createTeam, team, refresh, close } = this.props;

    const { name, description, dateTo, dateFrom } = this.state;

    const { NotificationCenter } = this.context;

    let resp;
    this.setState({ loading: true });
    if (team) {
      resp = await updateTeam(team.id, {
        name,
        description,
        dateTo: moment(dateTo).format("YYYY-MM-DD HH:mm:ss"),
        dateFrom: moment(dateFrom).format("YYYY-MM-DD HH:mm:ss"),
      });
    } else {
      resp = await createTeam({
        name,
        description,
        dateTo: moment(dateTo).format("YYYY-MM-DD HH:mm:ss"),
        dateFrom: moment(dateFrom).format("YYYY-MM-DD HH:mm:ss"),
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: team ? "Team has been updated." : "Team has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const { classes, fullScreen, open, team, close } = this.props;

    const { name, loading, description, dateTo, dateFrom } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        onClose={close}
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {team ? `${team.name}` : "Let's Create a New Team"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {team
                  ? "To update the team, fill the form below :"
                  : "To create a new team, fill the form below :"}
              </DialogContentText>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    label="Name"
                    className={classes.textField}
                    value={name}
                    onChange={this.handleChange("name")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="description"
                    label="Description"
                    className={classes.textField}
                    value={description}
                    onChange={this.handleChange("description")}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="dateFrom"
                    label="From"
                    type="date"
                    className={classes.textField}
                    value={moment(dateFrom).format("YYYY-MM-DD")}
                    onChange={this.handleChange("dateFrom")}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="dateTo"
                    label="To"
                    type="date"
                    className={classes.textField}
                    value={moment(dateTo).format("YYYY-MM-DD")}
                    onChange={this.handleChange("dateTo")}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {team && (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} />
                  &nbsp;Delete
                </Button>
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} />
                &nbsp;Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />
                {team ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormTeam));
